import { Button, Card, Col, Divider, Flex, Input, Row, Space, Statistic, Typography } from 'antd';
import _ from 'lodash';
import AddDebt from 'components/debt/AddDebt';
import AddPayment from 'components/debt/AddPayment';
import CustomerInfoModal from 'components/customer/InfoModal2';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';

const { Search } = Input;
const { Text } = Typography;

const DebtListMobile = ({ viewModel }) => {
  const {
    data,
    setFilterValue,
    onSearch,
    onSaved,
    showCustomer,
    clickPhone,
    showCustomerInfo,
    setShowCustomerInfo,
  } = viewModel;

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' style={{ width: '100%' }}>
          <Search
            placeholder='Số điện thoại hoặc tên'
            onSearch={onSearch}
            onChange={(e) => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
          />

          <Divider></Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Statistic title='Tổng số khách hàng' value={data.length} />
            </Col>
            <Col span={12}>
              <Statistic title='Tổng số nợ' value={_.sumBy(data, (item) => item.debt?.current_debt ?? 0)} precision={0} />
            </Col>
          </Row>

          <Flex justify='flex-end' style={{ width: '100%' }}>
            <Space>
              <AddPayment onSaved={onSaved}></AddPayment>
              <AddDebt onSaved={onSaved}></AddDebt>
            </Space>
          </Flex>
        </Space>
      </Card>

      <Card style={{ width: '100%' }}>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          {(data || []).map((record) => (
            <Card key={record.phone || record.id} bodyStyle={{ padding: 12 }}>
              <Space direction='vertical' size={8} style={{ width: '100%' }}>
                <Flex justify='space-between' align='center' gap={8}>
                  <Button type='link' onClick={() => showCustomer(record.id)} style={{ paddingInline: 0 }}>
                    {record.phone}
                  </Button>
                  <Text strong>{record.full_name || '-'}</Text>
                </Flex>

                <Flex justify='space-between'>
                  <Text type='secondary'>Còn nợ</Text>
                  <Text strong>{formatCurrency(record.debt?.current_debt || 0)}</Text>
                </Flex>

                <Flex justify='space-between' gap={8}>
                  <Text type='secondary'>Thanh toán gần nhất</Text>
                  <Space direction='vertical' size={0} style={{ alignItems: 'flex-end' }}>
                    <Text>{record.debt?.last_payment_date ? formatDate(record.debt.last_payment_date) : '-'}</Text>
                    <Text>{formatCurrency(record.debt?.last_payment_amount || 0)}</Text>
                  </Space>
                </Flex>
              </Space>
            </Card>
          ))}

          {!data?.length ? (
            <Card style={{ textAlign: 'center' }}>
              <Text type='secondary'>Không có dữ liệu công nợ</Text>
            </Card>
          ) : null}
        </Space>
      </Card>

      <CustomerInfoModal id={clickPhone} open={showCustomerInfo} onClose={() => setShowCustomerInfo(false)}></CustomerInfoModal>
    </Space>
  );
};

export default DebtListMobile;